import React, {
  forwardRef,
  lazy,
  Suspense,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { CommonModal } from "../../Modal";

const TrailingOrdersModal = lazy(() =>
  import("../../Modal").then((module) => ({
    default: module.TrailingOrdersModal,
  }))
);

const TradeManageModals = forwardRef(({}, ref) => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
  });

  useImperativeHandle(ref, () => ({
    setIsShow: (data) => setIsShow((prev) => ({ ...prev, ...data })),
  }));

  useEffect(() => {
    if (isShow.isOpen) {
      setIsShow((prev) => ({
        ...prev,
        modalContent: TrailingOrdersModal,
      }));
    }
  }, [isShow.isOpen]);

  const handleModalHide = () => {
    setIsShow({
      isOpen: false,
      rowData: {},
      name: "",
      modalContent: null,
      modalTitle: "",
    });
  };

  return (
    <>
      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={handleModalHide}
        modalTitle={isShow.modalTitle}
      >
        {isShow?.modalContent && (
          <Suspense fallback={<>Loading...</>}>
            {React.createElement(isShow?.modalContent, {
              handleShowHide: handleModalHide,
              rowData: isShow?.rowData,
            })}
          </Suspense>
        )}
      </CommonModal>
    </>
  );
});

export default TradeManageModals;
